import { useCallback } from 'react';
import { BinaryStatusCategory, useFilterContext } from '../filter-context';
import { ISSUE_NAVIGATOR_URL } from '../utils';
var buildJQLAdvancedIssueUrl = function buildJQLAdvancedIssueUrl(jql) {
  return "/issues/?jql=".concat(jql);
};
var buildJiraSearchUrl = function buildJiraSearchUrl(query) {
  return "/jira/search?searchString=".concat(encodeURIComponent(query));
};
var buildSmartQueryAdvancedSearchUrl = function buildSmartQueryAdvancedSearchUrl(query) {
  return "/secure/QuickSearch.jspa?searchString=".concat(encodeURIComponent(query));
};
var buildJqlQuery = function buildJqlQuery(query, projectIds, accountIds, binaryStatusCategories) {
  var projectJQL = projectIds.length > 0 ? " AND project IN (".concat(encodeURIComponent(projectIds.join(',')), ")") : '';
  var assigneeJQL = accountIds.length > 0 ? " AND assignee IN (".concat(encodeURIComponent(accountIds.join(',')), ")") : '';
  var binaryStatusCategoryValues = binaryStatusCategories.map(function (id) {
    switch (id) {
      case BinaryStatusCategory.DONE.id:
        return BinaryStatusCategory.DONE.jqlValue;
      case BinaryStatusCategory.OPEN.id:
        return BinaryStatusCategory.OPEN.jqlValue;
      default:
        return '';
    }
  }).join(', ');
  var binaryStatusCategoryJQL = binaryStatusCategories.length === 1 ? " AND statusCategory IN (".concat(encodeURIComponent(binaryStatusCategoryValues), ")") : '';
  return "text ~ \"".concat(encodeURIComponent(query), "\"").concat(projectJQL).concat(assigneeJQL).concat(binaryStatusCategoryJQL);
};
var buildJiraAdvancedSearchPath = function buildJiraAdvancedSearchPath(query, availableProjectFilters, availableAssigneeFilters, availableBinaryStatusCategories) {
  var trimmedQuery = query.trim();
  if (!trimmedQuery) {
    // If query is empty, we utilise a spa transition with ISSUE_NAVIGATOR_URL
    return query === '' ? ISSUE_NAVIGATOR_URL : buildSmartQueryAdvancedSearchUrl(query);
  }
  var projectIds = availableProjectFilters.filter(function (f) {
    return f.isChecked;
  }).map(function (f) {
    return f.id;
  });
  var accountIds = availableAssigneeFilters.filter(function (f) {
    return f.isChecked;
  }).map(function (f) {
    return f.id;
  });
  var binaryStatusCategories = availableBinaryStatusCategories.filter(function (f) {
    return f.isChecked;
  }).map(function (f) {
    return f.id;
  });

  /*
     If no filters are specified, we route the user to the "smart" query url (/secure/QuickSearch.jspa)
     as we want to retain the smart querying functions it has (e.g. routing you to an issue directly if you enter an issue key)
     */
  if (projectIds.length === 0 && accountIds.length === 0 && binaryStatusCategories.length === 0) {
    return buildJiraSearchUrl(trimmedQuery);
  }
  return buildJQLAdvancedIssueUrl(buildJqlQuery(trimmedQuery, projectIds, accountIds, binaryStatusCategories));
};
export var buildJiraAdvancedSearchUrl = function buildJiraAdvancedSearchUrl(query, availableProjectFilters, availableAssigneeFilters, availableBinaryStatusCategories, siteUrl) {
  return "".concat(siteUrl !== null && siteUrl !== void 0 ? siteUrl : '').concat(buildJiraAdvancedSearchPath(query, availableProjectFilters, availableAssigneeFilters, availableBinaryStatusCategories));
};
export var useFiltersAdvancedSearchUrlFactory = function useFiltersAdvancedSearchUrlFactory() {
  var _useFilterContext = useFilterContext(),
    availableProjectFilters = _useFilterContext.projectFilters.availableFilters,
    availableAssigneeFilters = _useFilterContext.assigneeFilters.availableFilters,
    availableBinaryStatusCategoryFilters = _useFilterContext.binaryStatusCategoryFilters.availableFilters;
  return useCallback(function (query, siteUrl) {
    return buildJiraAdvancedSearchUrl(query, availableProjectFilters, availableAssigneeFilters, availableBinaryStatusCategoryFilters, siteUrl);
  }, [availableProjectFilters, availableAssigneeFilters, availableBinaryStatusCategoryFilters]);
};
export var useQueryOnlyAdvancedSearchUrlFactory = function useQueryOnlyAdvancedSearchUrlFactory() {
  return useCallback(function (query, siteUrl) {
    return buildJiraAdvancedSearchUrl(query, [], [], [], siteUrl);
  }, []);
};